import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from '../../connectors/localstorage';
import { ModalViewDetailRequestTypeComponent } from '../../modals/modal-view-detail-request-type/modal-view-detail-request-type.component';
import { UserBehaviorService } from '../../services/user-events/user-behavior.service';
import tippy, { hideAll } from 'tippy.js';
import { ModalDetailsSetupComponent } from '../../modals/modal-details-setup/modal-details-setup.component';
import { ObservableService } from '../../services/observable.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

@Component({
  selector: 'app-actions-request-setup',
  templateUrl: './actions-request-setup.component.html',
  styleUrls: ['./actions-request-setup.component.css'],
  standalone: true,
  imports: [MatMenuModule, NgIf]
})
export class ActionsRequestSetupComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() respTable?: any;
  @Input() params?: any;
  @Output() rowData?: any;
  @Input() closeModal?: boolean;
  cellValue: any;
  private isOpen = false;
  private tippyInstance: any;

  @ViewChild('content', { static: false }) container?: ElementRef;
  @ViewChild('trigger') button: any;
  private gridApi!: GridApi<any>;

  userID: any;
  isUserName: any;
  pathUrl: any;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private changeDetector: ChangeDetectorRef,
    private dialog: MatDialog,
    private serviceLocalStorage: LocalStorageService,
    private userBehavior: UserBehaviorService,
    private router: Router,
    private observableService: ObservableService
  ) {
    this.userBehavior.selectedUser.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.isUserName = value.name;
    });
  }

  private getUserId() {
    this.userID = Number(this.serviceLocalStorage.decryptAndGet('userId'));
  }

  ngAfterViewInit(): void {
    this.tippyInstance = tippy(this.button?.nativeElement);
    this.tippyInstance.disable();
  }

  ngOnInit(): void {
    const currentPath = this.router.url;
    this.pathUrl = currentPath;
  }

  agInit(params: any) {
    this.gridApi = params.api;
    this.params = params?.data;
  }

  onClickHandler(option: string) {
    this.togglePopup();
  }

  configureTippyInstance() {
    this.tippyInstance.enable();
    this.tippyInstance.show();

    this.tippyInstance.setProps({
      trigger: 'manual',
      placement: 'left',
      arrow: false,
      interactive: true,
      appendTo: document.body,
      hideOnClick: false,
      onShow: (instance: any) => {
        hideAll({ exclude: instance });
      },
      onClickOutside: (instance: { unmount: () => void }, event: any) => {
        instance.unmount();
      }
    });
  }

  togglePopup() {
    this.isOpen = !this.isOpen;
    this.changeDetector.detectChanges();
    if (this.isOpen) {
      this.configureTippyInstance();
      this.tippyInstance.setContent(this.container?.nativeElement);
    } else {
      this.tippyInstance.unmount();
    }
  }

  viewDetailsByAction() {
    if (this.pathUrl == '/task-management/request-setup') {
      this.params.actions.viewDetail.modal['idUser'] = this.userID;
      const dialogRef = this.dialog.open(ModalViewDetailRequestTypeComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        width: '60%',
        height: '70%',
        panelClass: '',
        position: {},
        data: {
          modal: this.params.actions.viewDetail.modal,
          shortName: this.params?.shortName
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.observableService.setVariable('viewDetailsSetup');
      });
    } else {
      this.params.actions.viewDetail.modal['idUser'] = this.userID;
      const dialogRef = this.dialog.open(ModalDetailsSetupComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        width: '60%',
        height: '70%',
        panelClass: '',
        position: {},
        data: {
          modal: this.params.actions.viewDetail.modal,
          users: this.params?.emailAddresses
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.observableService.setVariable('viewDetailsSetup');
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
